// src/pages/AboutPage.jsx
import { Link } from 'react-router-dom';
import { FaAward, FaUsers, FaRocket, FaShieldAlt, FaGlobeAfrica } from 'react-icons/fa';
import Layout, { useLanguage } from '../components/Layout';

export default function AboutPage() {
  const { t } = useLanguage();

  return (
    <Layout>
      <div className="page-container">
        <div className="page-content">
          <h1>{t('about.title') || 'About Nexcom'}</h1>
          <p className="page-subtitle">
            {t('about.subtitle') || 'Connecting Kenya with reliable internet since 2005'}
          </p>

          <div className="about-grid-page">
            <div className="about-text">
              <h2>{t('about.story') || 'Our Story'}</h2>
              <p>
                {t('about.storyText1') || 'Nexcom is a CA Licensed NFP Tier 2 ISP with over 20 years of network operations experience across East Africa. We specialize in providing fixed wireless internet solutions for homes and businesses in Kisumu and surrounding areas.'}
              </p>
              <p>
                {t('about.storyText2') || 'Our mission is to deliver high-speed, reliable, and affordable internet connectivity that empowers individuals and businesses to thrive in the digital economy.'}
              </p>
              <h2>{t('about.whyChoose') || 'Why Choose Nexcom'}</h2>
              <ul className="about-features">
                <li><FaAward /> {t('about.feature1') || '20+ Years of Experience'}</li>
                <li><FaUsers /> {t('about.feature2') || '10,000+ Satisfied Customers'}</li>
                <li><FaRocket /> {t('about.feature3') || 'Fiber-fast Wireless Technology'}</li>
                <li><FaShieldAlt /> {t('about.feature4') || 'Licensed & Regulated by CAK'}</li>
                <li><FaGlobeAfrica /> {t('about.feature5') || 'East Africa Network Operations'}</li>
              </ul>
            </div>

            <div className="about-stats">
              <div className="stat-card">
                <div className="stat-number">20+</div>
                <div className="stat-label">{t('about.stat1') || 'Years of Experience'}</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">10K+</div>
                <div className="stat-label">{t('about.stat2') || 'Happy Customers'}</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">99.9%</div>
                <div className="stat-label">{t('about.stat3') || 'Uptime Guarantee'}</div>
              </div>
              <div className="stat-card">
                <div className="stat-number">24/7</div>
                <div className="stat-label">{t('about.stat4') || 'Customer Support'}</div>
              </div>
            </div>
          </div>

          <div className="cta-section-page">
            <h3>{t('about.ctaTitle') || 'Ready to get connected?'}</h3>
            <Link to="/#contact" className="cta-button-page">
              {t('about.ctaButton') || 'Contact Us Today'}
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}